<div class="columns-selector-button" #columnsSelector (click)="openColumnsSelectorOverlay()">
  <img src="dist/tiime-material/assets/ic_column_filter.svg" alt="Icône sélection de colonne" />
</div>
